module.exports = ".hoje{color:#ffffff !important;background-color:#d11818 !important}\n"